var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59401 1.63637L12.3008 11.3474C14.4179 13.4604 17.8786 13.4623 19.9975 11.3474L29.7043 1.63637C29.802 1.53861 29.7878 1.37763 29.6744 1.29854C28.6843 0.608071 27.4798 0.19873 26.1822 0.19873H6.11617C4.81854 0.19873 3.61396 0.608141 2.6239 1.29854C2.5105 1.37763 2.49625 1.53861 2.59401 1.63637ZM0 6.31483C0 5.29447 0.252987 4.33038 0.698608 3.483C0.768294 3.35043 0.944928 3.32363 1.05082 3.42952L10.6348 13.0135C13.6697 16.0528 18.6268 16.0546 21.6636 13.0135L31.2475 3.42952C31.3534 3.32363 31.5301 3.35043 31.5998 3.483C32.0453 4.33038 32.2984 5.29454 32.2984 6.31483V19.0826C32.2984 22.4576 29.553 25.1987 26.1822 25.1987H6.11617C2.74545 25.1987 0 22.4576 0 19.0826V6.31483Z",
    fill: "#808897"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.aaaa6a1008c5a4c346745cc92d61efd9.svg";
export { ForwardRef as ReactComponent };